import styled from 'styled-components';

export const Content = styled.div``;

/* Alignment and nothing else — see the note in the user list's copy. */
export const Div = styled.div`
  &.captal {
    text-transform: capitalize;
  }
`;
